import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { render_amount } from 'utils';
import { ChooseColor } from 'ui/components';
import { FormattedMessage } from 'ui/i18n';

import './ItemPreview.scss';

@observer
export default class ItemPreview extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		itemsInPack: PropTypes.number,
		handleAddToCart: PropTypes.func.isRequired,
		showChooseColor: PropTypes.bool.isRequired,
		toggleModal: PropTypes.func.isRequired,
	};

	static defaultProps = {
		itemsInPack: 0,
	};
	getTitle() {
		if (this.props.item.is_pack) {
			return this.props.item.name;
		} else if (this.props.item.is_configurable) {
			return `${this.props.item.base_number} - ${this.props.item.name}`;
		}
		return `${this.props.item.number} - ${this.props.item.name}`;
	}

	onClick() {
		this.props.handleAddToCart();
	}

	handleModalToggle() {
		this.props.toggleModal();
	}

	render() {
		const { item, itemsInPack } = this.props;

		return (
			<div className="col-md-2 col-sm-2 col-xs-2 ItemPreview" id="ItemPreview">
				<h4 id="ItemPreviewTitle">
					{this.getTitle()}
				</h4>
				{item.is_pack &&
					<h4 id="ItemPreviewPackItems">
						({itemsInPack}
						<FormattedMessage id="packDetails.itemsInPackText" />)
					</h4>}

				{item.is_configurable &&
					<div
						className="choose-color"
						onClick={this.handleModalToggle.bind(this)}
					>
						<FormattedMessage id="general.chooseColorText" />
					</div>}

				{item.is_configurable &&
					<ChooseColor
						show={this.props.showChooseColor}
						onRequestClose={this.handleModalToggle.bind(this)}
						item={item}
						handleAddToCart={this.onClick.bind(this)}
					/>}

				<div className="ItemPreview--price">
					<div className="promo-price-header" id="ItemPreview-promo">
						Promo
					</div>
					<p className="promo-price-content" id="ItemPreview-promo-price">
						{render_amount(item.promo_price, item)}
					</p>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ItemPreview/index.js